import React from 'react'
import { Skeleton } from '@fs/zion-ui'
import { css } from '@emotion/core'

const labelWrapperCss = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacer-nano);
  min-height: 150px;
`

export default function SourceGridLabelCellSkeleton(): JSX.Element {
  return (
    <div css={labelWrapperCss} aria-hidden>
      <Skeleton.H5 maxWidth="65%" />
      <Skeleton.Paragraph maxWidth="80%" />
    </div>
  )
}
